import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { timer } from 'rxjs/internal/observable/timer';
import { shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { AddressBookContactDTO } from '@sb-tools/typescript/models/dto/address-book-contact.dto';
import { map } from 'rxjs/internal/operators/map';

const CACHE_SIZE = 1;
const REFRESH_INTERVAL = 60000; // one minute

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    private contacts: Observable<AddressBookContactDTO[]>;
    private unsubscriber = new Subject<void>();

    constructor(private httpClient: HttpClient) {}

    getAll(): Observable<AddressBookContactDTO[]> {
        return this.httpClient.get<AddressBookContactDTO[]>(environment.apiInboxUrl + 'addressbook/contacts');
    }

    getAllFromCache(): Observable<AddressBookContactDTO[]> {
        const timerForUpdate = timer(0, REFRESH_INTERVAL);

        if (!this.contacts) {
            this.contacts = timerForUpdate.pipe(
                switchMap(() => {
                    return this.getAll();
                }),
                takeUntil(this.unsubscriber),
                shareReplay(CACHE_SIZE),
            );
        }

        return this.contacts.pipe(
            map((value) => {
                return structuredClone(value);
            }),
        );
    }
}
